<template>
  <div></div>
</template>

<script>
import Auth from "@/modules/Auth";
import { mapActions } from "vuex";
import Global from "@/constants/Global.js";

export default {
  name: "Redirect",
  data() {
    return {};
  },
  created() {
    let self = this;
    let type = self.$route.query.type;
    const query = self.$route.query;
    const userId = localStorage.getItem("user_id");
    if (userId && type !== "item-detail") {
      self.deauth();
      // reload
      location.reload();
    } else {
      switch (type) {
        case "activation":
          self.$route.path !==
            `/activation?id=${query.user}&token=${query.token}` &&
            self.$router.push(
              `/activation?id=${query.user}&token=${query.token}`
            );
          break;
        case "password":
          self.$route.path !==
            `/password-reset?user_id=${query.user_id}&token=${query.token}` &&
            self.$router.push(
              `/password-reset?user_id=${query.user_id}&token=${query.token}`
            );
          break;
        case "facebook":
          self.facebookTokenVerification(query.token);
          break;
        case "emailChange":
          self.commonTokenVerification(query.token);
          break;
        case "item-detail":
          self.$route.path !== `/s-app/item-details/${query.item}` &&
            self.$router.push(`/s-app/item-details/${query.item}`);
          break;
        default:
          self.$route.path !== "/" && self.$router.push("/");
          break;
      }
    }
  },
  methods: {
    ...mapActions(["endSession", "startSession", "getAllGroups"]),
    commonTokenVerification(token) {
      let self = this;
      fetch(Global.getServerDomain() + "/token", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          token: token,
        }),
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.result) {
            localStorage.setItem("token", token);
            self.startSession(response.id);
            self.getAllGroups();
            self.$route.path !== "/profile-page/" + response.id &&
              self.$router.push("/profile-page/");
          }
        });
    },
    deauth() {
      let self = this;
      Auth.deauthenticateUser();
      localStorage.removeItem("user_id");
      console.log("passei");
      self.endSession();
    },
    facebookTokenVerification(token) {
      let self = this;
      fetch(Global.getServerDomain() + "/token", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          token: token,
        }),
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.result) {
            // break
            if (response.activated === 1) {
              localStorage.setItem("token", token);
              self.getAllGroups();
              self
                .startSession(response.id)
                .then(() => self.$router.push("/s-app/feed"));
            } else if (response.activated === 2) {
              fetch(Global.getServerDomain() + `/reactivation`, {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  auth_key: Auth.getToken(),
                },
                body: JSON.stringify({
                  id: response.id,
                }),
              })
                .then((res) => res.json())
                .then(function () {
                  self.$router.push({
                    name: "detail-child",
                    params: { id: response.id },
                    query: { feature: "reactivation" },
                  });
                });
            } else {
              self.$router.push(
                "/activation?facebook=true&id=" +
                  response.id +
                  "&fbtoken=" +
                  token
              );
            }
          }
        });
    },
  },
};
</script>
